import logo from "../assets/images/remax-logo_brandlogos.net_za64u-512x512.png";
import headshot from "../assets/images/headshot.jpg";
import {
  faFacebook,
  faInstagram,
  faTwitter,
  faYoutube,
  faLinkedin,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import { FaAward, FaStar } from "react-icons/fa6";
import house1 from "../assets/images/shutterstock_555325381-min.jpg";
import house2 from "../assets/images/shutterstock_2200985705-min.jpg";
import house3 from "../assets/images/shutterstock_2368724057-min.jpg";
import house4 from "../assets/images/shutterstock_1699684264-min.jpg";
import house5 from "../assets/images/House6.jpg";
import house6 from "../assets/images/House7.jpg";
import agent1 from "../assets/images/shutterstock_2510015507-min.jpg";
import agent2 from "../assets/images/shutterstock_567772042-min.jpg";
import agent3 from "../assets/images/Smiling_Professional-min.jpg";
import agent4 from "../assets/images/shutterstock_2423464835-min.jpg";
import agent5 from "../assets/images/shutterstock_1608751048.jpg";
import house from "../assets/images/shutterstock_617467400-min.jpg";

import homeImage from "../assets/images/home-bg.jpg";
import calculatorImage from "../assets/images/calculator-bg.jpg"
import reportsImage from "../assets/images/reports-bg.jpg"
import evaluationImage from "../assets/images/evaluation-bg.jpg"
import testimonialsBgImage from "../assets/images/testimonials-bg.jpg"
import aboutBgImage from "../assets/images/about-bg.jpg"


const Highlight = ({ children, className }) => {
  return (
    <span
      className={
        "bg-cyan-600/20 p-1 py-0.5 font-bold text-cyan-600 dark:bg-cyan-600/20 dark:text-cyan-600" + className
      }
    >
      {children}
    </span>
  );
};


const constants = {
  ABOUT_BG_IMAGE: aboutBgImage,
  HERO_SLOGAN: "Your Trusted Real Estate Partner",
  HERO_SUBTITLE: "With over 14 years of experience, I specialize in residential and investment property sales, offering personalized guidance and expert negotiation skills.",
  HERO_CTA_TEXT: "Get Started",
  HERO_CTA_LINK: "/contact",
  BROKERAGE_NAME: "Kingsway Real Estate Brokerage",
  BROKERAGE_NUMBER: "905 277 2000",
  BROKERAGE_EMAIL: "help@remax.com",
  AGENT_NAME: "Nick Smithers",
  AGENT_TITLE: "Real Estate Agent",
  AGENT_NUMBER: "416 948 4757",
  AGENT_EMAIL: "nick@example.com",
  BROKERAGE: "Kingsway Real Estate Brokerage",
  MAP: "https://www.google.com/maps?q=3180+Ridgeway+Dr,+Mississauga,+ON+L5L+5S7&output=embed",
  SOCIALS: {
    // twitter: "https://www.x.com",
    facebook: "https://www.facebook.com/nick.smithers.5",
    instagram: "https://www.instagram.com/nick.smithers.5/",
    youtube: "https://www.youtube.com/@nick.smithers.5",
    // linkedIn: "fssfsf",
    // tikTok: "sfsfsf",
  },
  ICONS: {
    twitter: faTwitter,
    facebook: faFacebook,
    instagram: faInstagram,
    youtube: faYoutube,
    linkedIn: faLinkedin,
    tikTok: faTiktok,
  },
  LOGO: logo,
  HEADSHOT: headshot,
  HOME_IMAGE: homeImage,
  AGENT_ID: process.env.REACT_APP_AGENT_ID,
  OFFICE_ID: process.env.REACT_APP_OFFICE_ID,
  TOKEN: process.env.REACT_APP_TOKEN,
  URL: process.env.REACT_APP_URL,
  ENVIRONMENT: process.env.REACT_APP_NODE_ENV,
  DOMAIN: "aptowebsites.com",
  EMAIL_ACCESS_KEY: "",
  ABOUT:
    "Client Satisfaction Is Our Motto.",
  FULL_ABOUT:
    "I'm Nick Smithers, a dedicated real estate broker with over 14 years of experience helping clients buy, sell, and lease residential and investment properties. Backed by more than 30 years of leadership and decision-making experience across various industries, I bring a strategic, results-driven approach to every transaction. With an MBA in Sales & Marketing, and certifications as a Project Management Professional (PMP) and Certified Six Sigma Black Belt (CSSBB), I offer a unique blend of business acumen, process efficiency, and market insight. My clients appreciate my professionalism, integrity, and the personalized guidance I provide throughout the real estate journey. I am Platinum/ VIP Broker of various preconstruction projects and have insider access. That saves our clients thousands of $$ and they get best incentives. Our precon service area is spread over Ontario, Alberta, and UAE Whether you're a first-time buyer, seasoned investor, or looking to sell at top value, I’m here to help you make confident, informed decisions in today’s dynamic market.",
  TESTIMONIALS: [
    {
      name: "Chris V.",
      img: agent4,
      quote: "Mr. KB Singh and his team provided an excellent services in real estate. He helped me buying property at lower price and sold my property at highest property in the community. He has references and network available at all levels such as lawyers, mortgage consultants, accountants, and inspectors. He and his team is my realtors for life.",
    },
    {
      name: "Simran S.",
      img: agent1,
      quote: "Working with Nick & his team was an absolute pleasure. Their deep knowledge of the market, professionalism, and unwavering dedication made the entire process seamless and stress-free. They truly went above and beyond to find the perfect home for us. Highly recommended! He Sold our house at the highest price in the neighborhood."
    },
    {
      name: "Sonika & Vishal",
      img: agent2,
      quote: "We recently bought a detached house through Mr. Nick Smithers. We were confident while signing and partnering with him. He is honest, and keeps his client's best interests, provided great feedback, and helped explain clearly details about the property. Mr. Nick Smithers's knowledge. professionalism, and terrific instincts have consistently guided us at every step of the house buying experience. His commitment and attention to detail, responsiveness, and ability to close the deal w'ere outstanding with exemplary negotiation skills!!! We would never hesitate to recommend him. We are confident that anyone would find him engaging, understanding and easy to work through. He possesses an excellent strategy and by far the BEST realtor and a great friend. Mr. Nick Smithers and his team are committed to delivering the highest quality to its customers. A great five-star experience all the way."
    },
    {
      name: "Veronica Z.",
      img: agent5,
      quote: "From our first meeting to the final closing, Broker Nick Smithers exceeded all our expectations. His expertise, responsiveness, and commitment to getting us the best deal were truly impressive. He took the time to understand our needs, guided us through every step of the process, and made what could have been a stressful experience feel effortless. Whether buying or selling, I wouldn’t trust anyone else. Nick is a true professional and a standout in the real estate industry.",
    },
    {
      name: "Emilio",
      img: agent5,
      quote: "Nick and team, we are sending a note to thank you for your efforts in helping us buy our first home. Your patience, experience and extensive knowledge made the whole process very easy. I would without a doubt, recommend Nick and his team to any person who is looking to buy or sell their home. Thank you Nick! You made our dream of owning a home come true!",
    },
    {
      name: "Michael W.",
      img: agent5,
      quote: "How was I first introduced to Nick and his services? After working briefly (we never met) with a Remax brokerage and finding his interest in me to be lacking I sought another realtor, possibly through theredpin.com or through MLS and Google and was introduced to Mr. Nick Smithers. Mr. Nick Smithers was far more responsive to my inquiries, and seemed to provide better feedback to my questions. When we met I found him pleasant and personable. I was confident after speaking with him that he was well informed on the area and the strategies necessary to get a good deal in the area. I feel the negotiation was handled by Nick very well, as the property sold for under asking and hopefully at or a couple thousand under fair market value. Prior properties that I have purchased were always through COMFREE and my lawyer, in areas that I was familiar with. This was my first experience working with a realtor. I do believe the relationship added value to the process in this case especially because I did not have my own network in the area. I would recommend Nick and Kingsway to others looking for a skilled realtor in the Brampton area.",
    },
    {
      name: "Gopinath R.",
      img: agent5,
      quote: "Thanks to Mr. KB, we found our dream townhome at an unbeatable price. Their sharp market insight, negotiation skills, and commitment to our goals helped us secure the best deal possible. We couldn't have asked for better guidance and support throughout the entire buying process.",
    },
    {
      name: "Naveed K",
      img: agent5,
      quote: "Selling our home with Team KBSingh was the best decision we made. Their strategic marketing, deep understanding of the market, and expert negotiation skills resulted in us selling our home quickly and at the best possible price. They kept us informed every step of the way and made the entire process smooth and stress-free. We highly recommend Broker Karambir Singh to anyone looking to sell their home with confidence.",
    },
    {
      name: "Amar P.",
      img: agent5,
      quote: "I’m so grateful to Nick for helping me find the perfect condo for lease. He listened to my needs, showed me great options, and guided me through the process with professionalism and care. His knowledge and responsiveness made everything smooth and stress-free. I'll definitely buy my next home with him.",
    },
  ],
  SELLING_GUIDE: [
    {
      heading: "Selling Your Home",
      text: "<p>There are a million different reasons why people sell their homes, but every seller has one thing in common: the desire to get as much money as possible from their existing residence as quickly and as hassle-free as possible. (If your home is your principal residence, you won't have to pay capital gains tax on any profits from the sale. If, on the other hand, it is an investment property, prepare for the tax man!) Before you begin the selling process, really evaluate why you're moving. Do you have too few rooms, or too many? Has your job moved to another city and you're relocating? Are the neighbours driving you away? Or are you simply looking for a change? A complete analysis of your current position will set a good foundation for your next home hunt.</p>\
        <br/>\
        <h3 style='font-size: 1.75em'>Buy or Sell First?</h3>\
        <br/>\
        <p>Buy or sell first? That's tricky. After all, if you find a purchaser for your existing home, before you've found a new one, you may find yourself living out of a suitcase if convenient closing dates cannot be negotiated. On the other hand, if you find your dream home before you have sold your existing home, you may be faced with carrying two mortgages for a time. So how do you manage? Easy. Do your homework and have a good idea about the neighbourhood and type of home you're looking for. Do an honest evaluation of your family's needs and budget. Speak to your sales representative and start your new home search as soon as your existing home hits the market. If you've found a home, before you've sold your existing one, use 'sale of your existing home' as a condition on your offer. If you don't sell your house within a fixed period of time, you can choose not to go through with the offer. This, however, is a difficult condition for many vendors to agree upon and you may find that you have to forgo your price negotiating power. Purchasing a home before you sell could be a risky strategy if you're counting on the proceeds from the sale. If you've found a purchaser before you've found your next home, use 'purchase of a new home' as a condition when you sign back the agreement. Again, it will only be for a fixed time. Even if you have not found the ideal next house by the time the deal closes, you may still wish to proceed with the offer. As a buyer with a sold house you will be in a better position to negotiate</p>\
        <br/>\
        <h3 style='font-size:1.75em'>Make Your House More Sellable<h3>\
        <br/>\
        <p>While we all believe that our home is our castle, our personal tastes may not appeal to everyone. Your sales representative will work with you to give you an impartial analysis of your home - how it relates to other \"competing\" homes on the market and how your home reflects current design and style trends. Your sales representative will also take a good look at the general condition and upkeep of your dwelling. Overall, your sales representative will work with you to position your home on the market so that your sales experience will take place as expeditiously as possible.</p>\
        <br/>\
        <h3 style='font-size:1.75em'>Advertise Your Home on Various Internet Real Estate Portals<h3>\
        <br/>\
        <p>Your home will be advertised on many Internet Real Estate Portals to ensure that the details of your home will be seen by a large number of potential buyers.</p>\
       <br/>\
        <h3 style='font-size:1.75em'>Arrange Showings<h3>\
        <br/>\
        <p>In addition to giving your home the once over with a mop and dust cloth, have your sales representative prepare a home feature sheet. This is a one-page synopsis of your home that highlights lot size, room dimensions, features and upgrades as well as utility costs and taxes. Prospective buyers will take a sheet and refer to it while viewing your home. Plus, it makes for a great reference sheet when the buyers are comparing properties. The Open House: This is usually not a pleasant experience. The upside is that you usually won't have to be there to act as a guide. The downside is that you might have a series of open houses over a few weeks, with people poking through all areas of your home. And you'll have the constant pressure of keeping your home looking its best. The Viewing: When a sales representative has a client who is interested in your home, they will first call to make an appointment with your sales representative. If you're lucky, you'll have time for the last-minute tidying. Of course, you can say no if the prospective purchaser wishes to come at an inconvenient time. During the viewing, make sure you give the viewer and the sales representative a feature sheet and get the sales representative's business card. Give viewers the freedom to wander around your home by themselves. Following may make them uncomfortable. The sales representative will stay with the prospects to offer some protection against theft or property damage.</p>\
        ",
    },
    {
      heading: "Choosing the Right Sales Representative",
      text: "<p>Our sales representative is a trained professional who knows all aspects of the real estate market. A sales representative will save you time, money and aggravation. As with purchasing a home, you want to list with the sales representative who is the expert in your location. After all, potential purchasers will be calling this same \"area expert\" to inquire about houses for sale. There will be a few sales representatives who are knowledgeable about your neighbourhood. Call them up and interview them. You need to feel comfortable with him or her, after all, they will be working for you.</p>\
        <br/>\
        <h3 style='font-size: 1.75em'>Should You Go With a Non-Exclusive or Exclusive Listing Arrangement?</h3>\
        <br/>\
        <p>If you enter into this type of arrangement with your sales representative, you are giving him or her the exclusive right to find a purchaser for your home. With this type of agreement, no other sales representative will bring potential buyers to your home, because only the listing sales representative is entitled to the commission. You may consider this type of arrangement in a Sellers' Market during which time there are more people interested in purchasing a home than there are homes available.</p>\
        <br/>\
        <h3 style='font-size:1.75em'>Understand Market Conditions<h3>\
        <br/>\
        <p>The real estate market is in constant flux, not only as a whole but in particular areas as well. Knowing what is going on in the overall and local real estate markets will help you understand how these conditions can affect the sale of your home. We've designed the following comparison to help give you an overview of the three significant market positions. When you meet with your sales representative, ask about the current state of the market.</p>\
        <br/>\
        <h3 style='font-size:1.75em'>Buyer's Market:<h3>\
        <br/>\
        <p>The supply of homes on the market exceeds demand.Characteristics: High inventory of homes. Few buyers compared to availability. Homes usually stay on the market longer. Prices are stable or perhaps dropping. Implications: Buyers spend more time looking for a home, and when they negotiate, they usually have more leverage.</p>\
       <br/>\
        <h3 style='font-size:1.75em'>Seller's Market:<h3>\
        <br/>\
        <p>The number of potential buyers exceeds the supply of homes on the market. Characteristics: There is a smaller inventory of homes with many buyers. Homes sell quickly. Prices usually increase. Implications: Prices may be higher or perhaps climbing. Buying decisions must be made quickly. Conditional offers may be rejected.</p>\
        <br/>\
        <h3 style='font-size:1.75em'>Balanced Market:<h3>\
        <br/>\
        <p>The number of homes on the market is roughly equal to the demand. Characteristics: Demand equals supply. Sellers accept reasonable offers. Homes sell within a reasonable time period. Prices generally remain stable. Implications: There is less tension among buyers and sellers. There is a reasonable number of homes to choose from.</p>\
        ",
    },
    {
      heading: "Closing the Sale",
      text: "<h3 style='font-size: 1.75em'>Home</h3>\
        <br/>\
        <p>Closing is a time of packing and organization. Be sure you do not pack anything that you agreed to sell! Unless you specifically mentioned certain fixtures, everything must remain in place. You are responsible for handing over the home in the same condition it was at the time of closing. This applies to everything that was in the agreement. If the home suffers a major disaster, you are responsible for telling the buyer, at which point the buyer may walk away from the deal and have the deposit returned. The buyer may also choose to close and receive any insurance proceeds. In this unfortunate event, remember not to make any repairs until you find out what the buyer wants to do.</p>\
        <br/>\
        <h3 style='font-size:1.75em'>The Closing<h3>\
        <br/>\
        <p>Once signing the agreement, both the seller and buyer are under a legal obligation to close. If you decide not to for whatever reason, the buyer has the right to sue. If the buyer decides to walk away from the deal, you can claim the buyer's deposit or sue for damages.</p>\
        ",
    },
  ],
  BUYING_GUIDE: [
    {
      heading: "Getting Started",
      text: "<p>The first question you're bound to ask is, \"How much home can I afford?\" That depends on a number of factors: Your selected location. Are you set on a specific area? Downtown? The suburbs? A rural setting? Your preferred type of home. Detached? Semi? Duplex? High-rise? Link? Townhouse? New or Resale? There are a variety of home styles you will want to explore. Your income. After all, it's not just the mortgage you have to take into account. There are property taxes, utilities, and in some cases condo or strata fees. As a general rule of thumb, your monthly home-carrying cost should not exceed 30-35% of your income. Market conditions. Is it a buyers', sellers' or balanced market? There are also additional costs to keep in mind. It's a good idea to work out exactly what you want and what you can afford before you begin the search. Be specific! After all, you don't want to suddenly come to the realization that your dream house has come with a nightmare of bills and expenses. Stick to looking at houses in your price range. The more you've thought it out, the better your sales representative can meet your needs. A part of deciding just what you can afford can be accomplished by meeting with your bank or a mortgage broker and negotiating a pre-approved mortgage. There are many types of mortgages and many different terms. Research all of your options. This ensures that there are no surprises once you're ready to make an offer. Once you've figured out your monthly expenses and what you can afford, you can start your search. It could happen that the first home you see is the one you want; or you might look at home after home with none of them catching your interest. Rest assured, the home you're looking for is out there, and when you find it, you're ready to make an offer. If your offer is accepted, the next steps are closing and moving into your new home. Purchasing a home is easy once you put your plans into action.</p>\
    ",
    },
    {
      heading: "What Can I Afford?",
      text: "<p>Homes come in every size, style and price range. Knowing what you can afford at the beginning of your search saves you time and disappointment later on. The following calculations outline the process financial institutions use to determine what you can afford.</p>\
    <br/>\
    <h3 style='font-size: 1.75em'>First Affordability Rule</h3>\
    <br/>\
    <p>Lenders such as banks and trust companies allow you to spend approximately 32%* of your gross monthly income on housing costs (including property taxes, heating and, if applicable, 50% of condominium fees. The ratio of debt to income is referred to as the Gross Debt Service ratio or GDS.\
<br/>\
The following calculation will you how much you can afford monthly for housing.\
<br/>\
Your gross monthly income __________________________\
<br/>\
Spouse’s gross monthly income ______________________\
<br/>\
Other monthly income ______________________________\
<br/>\
Total monthly income _______________________________\
<br/>\
Monthly income x 32% = GDS ________________________</p>\
    <br/>\
    <h3 style='font-size:1.75em'>Second Affordability Rule<h3>\
    <br/>\
    <p>The second affordability rule is that your entire monthly debt load shouldn't be more that 40% of your gross monthly income. This includes housing costs and other debts, such as car loans and credit card payments. Lenders add up these debts to determine what percentage they are of your gross household monthly income. This is your Total Debt Service (TDS) ratio.\
<br/>\
<br/>\
The following calculation will you what you can afford for housing including your outstanding debts:\
<br/>\
<br/>\
A) Monthly Income from your GDS Calculation Above x 40% = TDS____________________\
<br/>\
B) Add up your monthly payments for loans, credit cards and other debts__________________\
<br/>\
Monthly income left for housing costs (subtract the amount from (A) from the amount in (B).\
<br/>\
In addition to GDS and TDS ratios, financial institutions base their lending decision on your credit history, job stability and the amount of your down payment. Interest rates also affect the amount of financing you will be able to obtain.\
<br/>\
<br/>\
*Please note that many lenders are prepared to exceed these guidelines.</p>\
",
    },
    {
      heading: "Your Buyer Team and Their Roles",
      text: "<h3 style='font-size: 1.75em'>Sales Representatives</h3>\
    <br/>\
    <p>A real estate sales representative is a professional who can save you time and trouble. And possibly even a lot of money. You see, real estate sales representatives have the home buying experience most people lack. They know all of the steps and they are good negotiators who will work on your behalf.\
<br/>\
<br/>\
A sales representative will:\
<br/>\
<br/>\
<ul >\
<li>\
Fine-tune your wants/needs list\
</li>\
<li>\
Get special computer access to listing information\
</li>\
<li>\
Screen houses so as not to waste your time\
</li>\
<li>\
Arrange appointments\
</li>\
<li>\
Offer helpful advice about the neighbourhood\
</li>\
<li>\
Introduce you to trusted contacts who should be on your team, such as mortgage brokers, lawyers, and home inspectors.\
</li>\
</ul>\
<br/>\
Above all, find a real estate sales representative who is a professional in the type of home you're looking for. A country home professional may not be the urban market specialist you need. And when speaking with your sales representative, be as clear as possible about your needs</p>\
    <br/>\
    <h3 style='font-size:1.75em'>Contractors<h3>\
    <br/>\
    <p>If you've decided to do some renovations on your home to make it more sellable, it's time to look for a credible contractor. Before anyone begins work on your home, it is important to do your homework.\
<br/>\
<br/>\
<span style='font-weight: 600'>Ask for Referrals</span>\
<br/>\
<br/>\
Your architect will make recommendations Your sales representative will offer some suggestions Contact friends or neighbours who have had similar work done Ask at your local builder supply store When you're interviewing contractors, ensure their credibility. Contact their references. Ask to see some samples of the contractor's work and speak to his clients to ensure that they were satisfied with the price, length of time in which the project was completed and overall, how the project was handled. Also, check with your local Better Business Bureau. Once you have the names of a few contractors that look promising, arrange to get estimates from them. By arranging for three quotes you'll get a good idea of the costs and quality of work. When going over the project with your contractor, ensure that he understands your needs and your budget. Each contractor will have a different idea on how to approach the work and they should inspect your home before giving an estimate. If contractors are bidding based on an architect's plans, be certain that they have detailed their approach to the job based on the drawings. What's more, if there is a significant difference in the price, ask the contractors to explain their estimates. And keep in mind that the lowest price is not always the best. A price that's too low may mean that the contractor has undercut to get the project and then may submit additional project costs once the project is underway. As well, a high price doesn't always mean that you're getting gouged. The contractor may have budgeted for higher quality materials and may offer workmanship that is of an overall better quality. In every case, before you sign the contract, be certain that it is as detailed as possible to the point of noting the specific finishes and brand names of the products to be installed.\
    <br/>\
    <br/>\
<span style='font-weight: 600'>Evaluating a Quotation</span>\
<br/>\
<br/>\
<ul>\
<li>\
Are the specific details of the project outlined?\
</li>\
<li>\
Are the specific costs detailed?\
</li>\
<li>\
Is there a provision for extra costs?\
</li>\
<li>\
Has a cap been set for the total project?\
</li>\
<li>\
Is there a firm project timeline?\
</li>\
<li>\
Has the contractor allotted time for inspections?\
</li>\
<li>\
Have you indicated that you wish to see all material receipts?\
</li>\
<li>\
Will the work be subcontracted?\
</li>\
</ul>\
</p>\
<h3 style='font-size: 1.75em'>Appraisers</h3>\
        <br/>\
        <p>Hiring an appraiser to appraise the value of a property you are considering to buy may seem sensible but it is highly unnecessary. Your lender will want their own personal appraiser anyway, so you could be wasting valuable money. As well, most sales representatives are competent and can do a \"Comparative Market Analysis\" for you, to establish a value range. The only situation where hiring an appraiser would become necessary is where the property is unusual with no comparable sales.</p>\
        <br/>\
        <h3 style='font-size:1.75em'>Lenders<h3>\
        <br/>\
                <p>The true test for a buyer is \"What else can we buy for the same or less money?\" In short, a lender is anyone who will give you money. There are private lenders and institutional lenders, like banks and credit unions. Even your brother-in-law can be your lender. Of course, when you're looking for a lender, you are looking for a long-term relationship and terms and rates which are beneficial to you. You really have a few options. You should go to a mortgage broker who will search the mortgage market for the best rates and conditions based on your circumstances. Usually, the broker is paid by the lender without cost to you. However, the cloudier your credit history, the more likely there will be a fee! A good mortgage broker will be connected to all major lenders through the mortgage market. You can also do your own search. With a good credit history, it's really not that complicated. Pick up your newspaper and you'll see what the different lending institutions are offering. Find the institution you feel you would be most comfortable with and one that offers the terms and conditions you're looking for. Then, go in person and negotiate your best deal. We'll go into more detail about this process in the arranging a mortgage section.</p>\
        <br/>\
        <h3 style='font-size: 1.75em'>Mortgage Brokers</h3>\
        <br/>\
        <p>This is a person who will do the work in finding the institution which offers the mortgage terms and conditions that are right for you. Much like an insurance broker, this professional works for you and can offer you an unbiased referral. Although most brokers are paid a finders fee by the lender, some will charge 2% of the total mortgage to find you a lender.</p>\
        <br/>\
         <h3 style='font-size: 1.75em'>Lawyers/Notaries</h3>\
        <br/>\
        <p>A lawyer is there to represent your interest, and to process the documentation required. The legal aspects differ from province to province. Your sales representative can recommend lawyers to advise you on the steps to be taken before the keys to your new home are presented to you. A lawyer helps ensure you are protected!</p>\
        <br/>\
         <h3 style='font-size: 1.75em'>Home Inspectors</h3>\
        <br/>\
        <p>Have the home inspected! Whether you make it a condition of purchase or not, having the property pre-inspected by a qualified home inspector will give you the added confidence that you've made the right decision. Be very careful to verify the qualifications of your home inspector because there are no government standards or licenses for home inspectors. Some home inspectors in Canada do not have any form of accreditation. For your protection make sure your home inspector is a member of (PACHI) or (OAHI). This is your assurance that they have met their education requirements, have the experience and carry E & O Insurance.</p>\
        <br/>\
         <h3 style='font-size: 1.75em'>Insurance Brokers</h3>\
        <br/>\
        <p>You'll want to make sure your property and valuables will be covered. A broker offers independent advice and can save you time, trouble and money. Plus, the bank will insist that you carry full insurance since your property is used as collateral against your mortgage.</p>\
        <br/>\
",
    },
    {
      heading: "Mortgage Types",
      text: "<h3 style='font-size:1.75em'>Conventional and High Ratio Mortgages<h3>\
    <br/>\
    <p>To qualify for a conventional mortgage, you simply have to have a 20% down payment of the purchase price, with the mortgage not exceeding 80% of the appraised value. If your down payment is less than 20%, then you qualify for a high-ratio mortgage. This type of mortgage requires loan insurance, which can cost an additional 0.6% to 4.50% of the mortgage amount. With this type of mortgage, you could also be limited to a maximum house price.</p>\
    <br/>\
    <h3 style='font-size: 1.75em'>Second Mortgage</h3>\
    <br/>\
    <p>Of course, if you cannot add on to your mortgage, you may consider a second mortgage. Each mortgage uses your home as security and gives the mortgagee the right to take your home if you default on your loan. The first mortgagee gets paid first in cases of default and has the best chance of recovering all of its money. So it only goes to figure that subsequent mortgages usually come with a higher interest rate.</p>\
    <br/>\
    <h3 style='font-size:1.75em'>Mortgage Features<h3>\
    <br/>\
    <p>Every lending institution is different, and each will have their own customizable mortgage options. When you're hunting for a lender and a home, see how the following features could be beneficial to you.</p>\
    <br/>\
    <h3 style='font-weight:600'>Prepayment<h3>\
    <br/>\
    <p>This is a wonderful option if you receive regular bonuses or if your income fluctuates throughout the year. With a pre-payment privilege, you have the right to make payments toward the principal portion of your mortgage over and above the monthly payments. A mortgage with a pre-payment option is closed. An open mortgage means you can pay the entire principal sum without notice of bonus.</p>\
   <br/>\
    <h3 style='font-weight:600'>Portability<h3>\
    <br/>\
    <p>If you still have time remaining on that fantastic loan you negotiated, portability is one option you'll want to discuss with your lender. Quite simply, it means transferring the balance of your current mortgage at the existing rates and with the existing terms and conditions, to your new home.</p>\
    <br/>\
    <h3 style='font-weight:600'>Assumability<h3>\
    <br/>\
    <p>Let's say that the vendor has negotiated a dynamite mortgage. With an assumable mortgage you, the purchaser, simply assume the obligations of the mortgage. This is a wonderful feature especially if the terms are more favourable than the existing market conditions would allow. Remember, when it is time for you to sell, you may still be liable for any mortgage you allow the buyer to assume. This means if the buyer stops making payments, you could be accountable for the payments. Be sure to have the subsequent buyer approved for the assumption of the payments, thereby avoiding this potential land mine.</p>\
    <br/>\
    <h3 style='font-weight:600'>Expandability<h3>\
    <br/>\
    <p>If you need additional funds down the road, will your mortgage terms allow you to increase the principal amount? Usually, your new rate will be a blended amount of the initial mortgage rate and the prevailing rates. It's a great option to discuss with your lender if you foresee large expenses in your future like renovation or education costs.</p>\
    ",
    },
  ],
  LOCATIONS: [
    {
      name: "Mississauga",
      searchTerm: "Mississauga",
      slug: "mississauga",
      img: house1,
      // description: "A very nice neighbourhood",
    },
    {
      name: "Oakville",
      searchTerm: "Oakville",
      slug: "oakville",
      img: house2,
      // description: "A very nice neighbourhood",
    },
    {
      name: "Brampton",
      searchTerm: "Brampton",
      slug: "brampton",
      img: house3,
      // description: "A very nice neighbourhood",
    },
    {
      name: "Toronto",
      searchTerm: "Toronto",
      slug: "toronto",
      img: house4,
    },
    {
      name: "Halton Hills",
      searchTerm: "Halton Hills",
      slug: "halton hills",
      img: house5,
    },
    {
      name: "Vaughan",
      searchTerm: "Vaughan",
      slug: "Vaughav",
      img: house6,
    },
  ],
  QUOTE: "Your trusted real estate partner for life",
  AWARDS: [
    {
      year: "2022",
      title: "Best Realtor Toronto",
      icon: FaAward,
    },
    {
      year: "2023",
      title: "Most Houses Sold",
      icon: FaStar,
    },
    {
      year: "2019",
      title: "Favourite Realtor",
      icon: FaAward,
    },
  ],
  NAV_ITEMS: [
    {
      label: "Home",
      href: "/",
      items: [],
    },
    {
      label: "About",
      href: "/about",
      items: [],
    },
    {
      label: "Buying",
      href: "",
      items: [
        { href: "/calculator", label: "Mortgage Calculator" },
        { href: "/listings", label: "Listings" },
      ],
    },
    {
      label: "Selling",
      href: "",
      items: [{ href: "/evaluation", label: "Free Home Evaluation" }],
    },
    {
      label: "Information",
      href: "",
      items: [{ href: "/real-estate-reports", label: "Real Estate Reports" }],
    },
    {
      label: "Contact",
      href: "/contact",
      items: [],
    },
  ],
  TESTIMONIALS: [
    {
      name: "Jessica Turner",
      role: "First-Time Homebuyer",
      description: (
        <p>
          Working with Nick Smithers was a fantastic experience. He made the
          entire process stress-free.
          <Highlight>
            We found our dream home in less than two weeks!
          </Highlight>{" "}
          Highly recommend Nick’s expertise and dedication.
        </p>
      ),
    },
    {
      name: "David Kim",
      role: "Home Seller",
      description: (
        <p>
          I was amazed by Nick Smithers&apos; professionalism and market
          knowledge.
          <Highlight>
            Our house sold above asking price within days.
          </Highlight>{" "}
          Truly the best real estate experience I’ve ever had.
        </p>
      ),
    },
    {
      name: "Priya Singh",
      role: "Relocating Family",
      description: (
        <p>
          The attention to detail and personalized service from Nick Smithers made
          all the difference.
          <Highlight>
            He listened to our needs and found the perfect neighbourhood for our
            family.
          </Highlight>{" "}
          Thank you, Nick, for making our move so easy!
        </p>
      ),
    },
    {
      name: "Liam O'Reilly",
      role: "Real Estate Investor",
      description: (
        <p>
          From listing to closing, Nick Smithers guided us every step of the way.
          <Highlight>His negotiation skills saved us thousands.</Highlight> I
          wouldn’t trust anyone else with my real estate needs.
        </p>
      ),
    },
    {
      name: "Sophia Martinez",
      role: "Condo Buyer",
      description: (
        <p>
          Buying my first home was daunting, but Nick Smithers made it enjoyable.
          <Highlight>
            Every question was answered with patience and clarity.
          </Highlight>{" "}
          I felt supported throughout the entire journey.
        </p>
      ),
    },
  ],

  // Evaluation page constants
  EVALUATION_TITLE: "FREE HOME EVALUATION",
  EVALUATION_SUBTITLE: "How much is your home worth in today's market? Find out with our free Home Evaluation",
  EVALUATION_DESCRIPTION: "Wondering how much your home would sell for in today's market? Please complete the form below and I would be happy to send you a Free Home Evaluation.",
  EVALUATION_IMAGE: evaluationImage,

  // Reports page constants
  REPORTS_TITLE: "FREE REAL ESTATE REPORTS",
  REPORTS_SUBTITLE: "Gain valuable insights into the market with our free Real Estate Reports",
  REPORTS_DESCRIPTION: "Get exclusive buyer & seller real estate reports to help you with your next purchase or sale. Get insider tips and tricks, and learn how to invest your time and money wisely in the real estate market. Just complete the form below, select all the reports you'd like to receive and have them emailed to your inbox right away. Get started now!",
  REPORTS_IMAGE: reportsImage,

  // Calculator page constants
  CALCULATOR_TITLE: "MORTGAGE CALCULATOR",
  CALCULATOR_IMAGE: calculatorImage,
  CALCULATOR_SUBTITLE:
    "Find a price range that works with your budget by using our Mortgage Calculator",
  CALCULATOR_DESCRIPTION: "Find a price range that works with your budget by using our Mortgage Calculator",
  CALCULATOR_IFRAME_URL: "https://www.mortgagecalculator.org/webmasters/?downpayment=80000&homevalue=400000&loanamount=320000&interestrate=7&loanterm=30&propertytax=2700&pmi=1&homeinsurance=1500&monthlyhoa=0",

  TOOLS: [
    {
      href: "/calculator",
      image: calculatorImage,
      alt: "Mortgage Calculator",
      title: "MORTGAGE CALCULATOR",
      subtitle: "Find a price range that works with your budget by using our Mortgage Calculator",
    },
    {
      href: "/real-estate-reports",
      image: reportsImage,
      alt: "Real Estate Reports",
      title: "FREE REAL ESTATE REPORTS",
      subtitle: "Gain valuable insights into the market with our free Real Estate Reports",
    },
    {
      href: "/evaluation",
      image: evaluationImage,
      alt: "Home Evaluation",
      title: "FREE HOME EVALUATION",
      subtitle: "How much is your home worth in today's market? Find out with our free Home Evaluation",
    },
  ],

  ABOUT_TITLE: "ABOUT ME",
  ABOUT_DESCRIPTION: "Nick Smithers is a dedicated real estate professional committed to helping you find your dream home or sell your property for the best value.",

  ANIMATION_CONFIG: {
    cardFadeIn: 0.6,  // seconds
    cardHoverScale: 1.07,
    iconGlow: true,
    iconGlowColor: "#00eaff",
    iconGlowBlur: "0 0 16px #00eaff, 0 0 32px #00eaff",
  },

  TESTIMONIALS_BG_IMAGE: testimonialsBgImage,

  NIGHT_THEME_COLORS: {
    background: "#18181b", // Main background
    card: "rgba(36, 39, 48, 0.7)", // Card glassmorphism
    accent: "#00eaff", // Accent color for glow
    text: "#fff",
    secondaryText: "#b3b3b3",
    border: "#23272f",
    glow: "#00eaff",
    awardCardGradient: "linear-gradient(135deg, #23272f 60%, #00eaff 100%)",
    aboutCardGradient: "linear-gradient(135deg, #23272f 60%, #ffb300 100%)",
    testimonialCardGradient: "linear-gradient(135deg, #23272f 60%, #00eaff 100%)", // For testimonials
    testimonialAvatarGlow: "0 0 24px #00eaff, 0 0 48px #00eaff",
    testimonialQuoteColor: "#00eaff",
    testimonialPaginationActive: "#00eaff",
    testimonialPaginationInactive: "#23272f",
  },
}

export default constants;
